import type SubscriptionsV1 from 'bundles/naptimejs/resources/subscriptions.v1';
import PaymentProcessorTypes from 'bundles/payments-common/common/PaymentProcessorTypes';

export const isStripeSubscription = (subscription?: SubscriptionsV1) => {
  const { paymentProcessorId } = subscription || {};

  return Boolean(
    paymentProcessorId &&
      [
        PaymentProcessorTypes.stripeConsumer,
        PaymentProcessorTypes.stripeConsumerSandbox,
        PaymentProcessorTypes.stripeBvConsumer,
        PaymentProcessorTypes.stripeBvConsumerSandbox,
      ].includes(paymentProcessorId)
  );
};
